import { cosmicDateRangePickerValueSchema } from '@taxbit-private/cosmic'
import { z } from 'zod'

import { filterAssetSchema } from 'pages/dashboard/helpers/dashboardFiltersTypes'

import { assetTypeSchema } from 'contexts/filters/assetTypes'

const customFieldValueSchema = z.object({
  id: z.string(),
  value: z.string(),
})

export const transactionsFilterFormSchema = z.object({
  dateRange: cosmicDateRangePickerValueSchema.catch({}),
  source: z.array(z.string()).catch([]),
  token: z.array(filterAssetSchema).catch([]),
  from: z.string().catch(''),
  txn_id: z.string().catch(''),
  source_type: z.array(z.string()).catch([]),
  asset_type: z.array(assetTypeSchema).catch([]),
  transaction_func: z.array(z.string()).catch([]),
  missing_price: z.preprocess((val) => {
    if (val === 'true') {
      return true
    }
    if (val === 'false') {
      return false
    }
    return val
  }, z.boolean().catch(false)),
  range: z.array(z.string()).catch([]),
  syncStatus: z.array(z.string()).catch([]),

  category: z.array(z.string()).catch([]),
  type: z.array(z.string()).catch([]),
  voucher: z.array(z.string()).catch([]),
  to: z.string().catch(''),
  wallet: z.string().catch(''),
  source_tags: z.array(z.string()).catch([]),
  amount_range_min: z.string().catch(''),
  amount_range_max: z.string().catch(''),
  memo: z.string().catch(''),
  select_custom_fields: z
    .array(
      z.object({
        id: z.string(),
        value: z.array(customFieldValueSchema),
      })
    )
    .catch([]),

  number_custom_fields: z
    .array(
      z.object({
        id: z.string(),
        value_min: z.string().default(''),
        value_max: z.string().default(''),
      })
    )
    .catch([]),

  string_custom_fields: z
    .array(
      z.object({
        id: z.string(),
        value: z.array(z.string()).catch([]),
      })
    )
    .catch([]),
  version: z.string().optional(),
})

export type TransactionsFilterFormFields = z.infer<typeof transactionsFilterFormSchema>

export const TRANSACTIONS_FILTERS_STORAGE_KEY = 'transactions_filters'
